import React from 'react';
import { useInput } from 'react-admin';
import { MultiImageUploadField } from './MultiImageUploadField';

interface MultiImageUploadInputProps {
    source: string;
    label?: string;
    helperText?: string;
    maxImages?: number;
}

export const MultiImageUploadInput: React.FC<MultiImageUploadInputProps> = ({
    source,
    label,
    helperText,
    maxImages
}) => {
    const {
        field,
        fieldState: { error },
    } = useInput({ source });

    return (
        <MultiImageUploadField
            source={source}
            value={field.value}
            onChange={field.onChange}
            label={label}
            helperText={helperText}
            maxImages={maxImages}
        />
    );
};